import Vue from 'vue';

Vue.use(require('luxon'));
